import { render, staticRenderFns } from "./EventOrder.vue?vue&type=template&id=9a858ba8&scoped=true&"
import script from "./EventOrder.vue?vue&type=script&lang=js&"
export * from "./EventOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a858ba8",
  null
  
)

export default component.exports